import type { JSX } from 'react';

interface UserMessageMenuProps {

    onCopy: () => void;
    onEdit?: () => void;
    
}

export function UserMessageMenu({ onCopy, onEdit }: UserMessageMenuProps): JSX.Element {

    return (
        <div className="flex items-center gap-2">

            <button
                type="button"
                className="icon-btn"
                onClick={onCopy}
                title="Copy to clipboard"
                aria-label="Copy to clipboard"
            >
                <i className="fas fa-copy" />
            </button>
            <button
                type="button"
                className="icon-btn"
                onClick={onEdit}
                title="Edit message"
                aria-label="Edit message"
            >
                <i className="fas fa-pen" />
            </button>
        </div>
    );
}